var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.001,
    viewBox: "0 0 14 14.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#aaa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-536.251 -530.347)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M541.714,530.347H537.1a.854.854,0,0,0-.854.854v4.61a.855.855,0,0,0,.854.854h4.609a.853.853,0,0,0,.854-.853h0V531.2A.855.855,0,0,0,541.714,530.347Zm-.341,5.122h-3.927v-3.926h3.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M549.4,530.347h-4.61a.855.855,0,0,0-.854.854v4.61a.856.856,0,0,0,.854.854h4.61a.854.854,0,0,0,.854-.853h0V531.2A.856.856,0,0,0,549.4,530.347Zm-.341,5.122h-3.927v-3.926h3.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M541.714,538.031H537.1a.854.854,0,0,0-.854.854v4.609a.854.854,0,0,0,.854.854h4.609a.852.852,0,0,0,.854-.852v-4.611A.854.854,0,0,0,541.714,538.031Zm-.341,5.122h-3.927v-3.927h3.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M549.4,538.031h-4.61a.854.854,0,0,0-.854.854v4.609a.855.855,0,0,0,.854.854h4.61a.853.853,0,0,0,.854-.852v-4.611A.855.855,0,0,0,549.4,538.031Zm-.341,5.122h-3.927v-3.927h3.927Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.09ea501e.svg";
export { ForwardRef as ReactComponent };